<template>
    <span v-if="mostrarBtnEnviarParaAprovacao">
        <b-button
            variant="primary"
            @click.stop="abrirEntregaEnviarParaAprovacao()"
        >
            <span>
                <i class="fa fa-arrow-circle-right"></i> Enviar para aprovação
            </span>
        </b-button>
        <b-modal
            id="modalEntregaEnviarParaAprovacao"
            v-model="mostrarModalEntregaEnviarParaAprovacao"
            @show="iniciarForm()"
        >
            <div slot="modal-title">
                Entrega - Enviar para Aprovação
                <app-status
                    v-if="entrega.manual"
                    status="ENTREGA MANUAL"
                ></app-status>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Modalidade da Entrega</label>
                        <b-form-select
                            :plain="true"
                            :options="modalidadeSelect"
                            v-model="modalidade"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="
                            $v.dataEntrega.$invalid && $v.dataEntrega.$model
                                ? false
                                : null
                        "
                        invalid-feedback="Data da entrega é obrigatória e deve ser menor ou igual a data atual"
                    >
                        <label class="required">Data da Entrega</label>
                        <date-picker
                            v-model="dataEntrega"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dataEntrega.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Carga Horária Entregue</label>
                        <b-form-input
                            type="number"
                            v-model="cargaHorariaEntregue"
                            @input="$v.cargaHorariaEntregue.$touch()"
                            :state="
                                $v.cargaHorariaEntregue.$error ? false : null
                            "
                            v-mask="'######'"
                            :disabled="entrega.manual"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            v-if="!$v.cargaHorariaEntregue.required"
                            >A carga horária entregue é
                            obrigatória</b-form-invalid-feedback
                        >
                        <b-form-invalid-feedback
                            v-if="
                                !$v.cargaHorariaEntregue.cargaHorariaPermitida
                            "
                            >Carga horária a ser entrege dever ser maior ou
                            igual a 1 e menor ou igual a
                            {{
                                entrega.cargaHorariaPrevista
                            }}</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="cargaHorariaDiferenteDoPrevisto">
                <b-col sm="12">
                    <b-alert show variant="danger">
                        <b-row>
                            <b-col sm="1">
                                <i class="fa fa-exclamation-circle fa-4x"></i>
                            </b-col>
                            <b-col sm="11">
                                <h4 class="ml-4">
                                    As horas restantes desta entrega não poderão
                                    ser realizadas posteriormente.
                                </h4>
                            </b-col>
                        </b-row>
                    </b-alert>
                </b-col>
            </b-row>
            <b-row v-if="diferenteDoPrevisto">
                <b-col sm="12">
                    <b-form-group>
                        <label
                            >Entrega diferente do previsto, por favor, descreva
                            a justificativa</label
                        >
                        <b-form-textarea
                            v-model="justificativa"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                            :rows="4"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <span class="mr-2">
                    <label class="required ml-3 pt-2"></label>
                    <label class="ml-2 pt-2">Campos Obrigatórios</label>
                </span>
                <b-button
                    variant="secondary"
                    @click.stop="fecharEntregaEnviarParaAprovacao()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarEnviarEntregaParaAprovacao()"
                    >Enviar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators'

const dataConsistente = (value, vm) =>
    vm.$moment(value, 'DD/MM/YYYY').isSameOrBefore(new Date())
const cargaHorariaPermitida = (value, vm) =>
    value >= 1 && value <= vm.entrega.cargaHorariaPrevista
const justificativaValida = (value, vm) =>
    vm.diferenteDoPrevisto ? helpers.req(value) : true

export default {
    name: 'entrega-anexo-form',
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalEntregaEnviarParaAprovacao: false,
            erros: [],
            dataEntrega: '',
            cargaHorariaEntregue: '',
            justificativa: '',
            modalidadeSelect: [
                { text: 'PRESENCIAL', value: 0 },
                { text: 'ON-LINE', value: 1 }
            ],
            modalidade: null
        }
    },

    methods: {
        abrirEntregaEnviarParaAprovacao() {
            this.mostrarModalEntregaEnviarParaAprovacao = true
            this.modalidade = null
        },

        iniciarForm() {
            if (this.entrega.manual) {
                this.cargaHorariaEntregue = this.entrega.cargaHorariaPrevista
            } else {
                this.cargaHorariaEntregue = ''
            }
        },

        fecharEntregaEnviarParaAprovacao() {
            this.mostrarModalEntregaEnviarParaAprovacao = false
            this.resetEntregaEnviarParaAprovacao()
        },

        resetEntregaEnviarParaAprovacao() {
            this.dataEntrega = ''
            this.cargaHorariaEntregue = ''
            this.justificativa = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarEnviarEntregaParaAprovacao() {
            let html
            if (this.cargaHorariaDiferenteDoPrevisto) {
                html = `Confirma o envio da entrega para aprovação?
                <br/><br/><div class="alert alert-danger" role="alert">
                <div class="row">
                            <div class="col-3">
                                <i class="fa fa-exclamation-circle fa-5x"></i>
                            </div>
                            <div class="col-9">
                                <h4>As horas restantes desta entrega não poderão ser realizadas posteriormente.</h4>
                            </div>
                        </div>
		             </div>`
            } else {
                html = `Confirma o envio da entrega para aprovação?`
            }

            this.$swal({
                title: 'Envio para Aprovação',
                html: html,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.enviarEntregaParaAprovacao()
                }
            })
        },

        enviarEntregaParaAprovacao() {
            let entregaParaAprovacao = {
                entregaId: this.entrega.entregaId,
                dataEntrega: this.$moment(this.dataEntrega, 'DD/MM/YYYY'),
                cargaHorariaEntregue: this.cargaHorariaEntregue,
                justificativa:
                    this.justificativa == '' ? null : this.justificativa,
                modalidade: this.modalidade
            }
            this.$store.dispatch('addRequest')
            this.entregasServicos
                .enviarEntregaParaAprovacao(entregaParaAprovacao)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterEntregaAtualizada')
                        } else {
                            this.$toast.success(
                                response.errors[0],
                                'ERRO',
                                this.$toastConfig.console.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnEnviarParaAprovacao() {
            let instrutoriaOk = false
            let consultoriaOk = false

            if (this.entrega.contratacao) {
                instrutoriaOk =
                    this.entrega.natureza === 'INSTRUTORIA' ? true : true
                // 	? this.entrega.temAnexos
                // 	: true
                // consultoriaOk =
                //     this.entrega.natureza === 'CONSULTORIA'
                //         ? this.entrega.temRaht && this.entrega.temAnexos
                //         : true
                if (this.entrega.natureza === 'CONSULTORIA') {
                    if (
                        this.entrega.raht.empresas &&
                        this.entrega.raht.empresas.length > 0
                    ) {
                        consultoriaOk =
                            this.entrega.temRaht && this.entrega.temAnexos
                    } else {
                        consultoriaOk = this.entrega.temRaht
                    }
                } else {
                    consultoriaOk = true
                }
            }

            let retorno =
                this.$temAcesso('CRED-FORN-ENTR-05') &&
                consultoriaOk &&
                instrutoriaOk &&
                (this.entrega.status === 0 || this.entrega.status === 3)
            return retorno
        },

        diferenteDoPrevisto() {
            return (
                ((this.cargaHorariaEntregue != '' &&
                    this.entrega.cargaHorariaPrevista !=
                        this.cargaHorariaEntregue) ||
                    (this.dataEntrega != '' &&
                        this.$moment(this.entrega.dataPrevisao).format(
                            'DD/MM/YYYY'
                        ) != this.dataEntrega)) &&
                this.$v.cargaHorariaEntregue.cargaHorariaPermitida
            )
        },

        cargaHorariaDiferenteDoPrevisto() {
            return (
                this.cargaHorariaEntregue != '' &&
                this.entrega.cargaHorariaPrevista != this.cargaHorariaEntregue
            )
        }
    },

    validations: {
        modalidade: {
            required
        },
        dataEntrega: {
            required,
            dataConsistente
        },
        cargaHorariaEntregue: {
            required,
            cargaHorariaPermitida
        },
        justificativa: {
            justificativaValida
        }
    }
}
</script>
